import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import LogosScreen from "./logos-screen";
import {setActiveRiddle, updateScrollPosition} from "../../ducks/duck-screen";

import {unlockLevel} from "../../ducks/duck-game";

class LogosScreenContainer extends React.Component {
	componentDidUpdate(prevProps, prevState, snapshot){
		if(this.props.alreadyInvoked || this.props.isDownloadingRiddles){
			return null
		}

		const { userRiddles,
			gameType,
			currentRiddleRange,
			unlockInvocation } = this.props;

		unlockInvocation();

		const gameTypeRiddles = userRiddles[gameType] || {};
		const currentRiddlesList = gameTypeRiddles[currentRiddleRange] || [];

		if(currentRiddlesList.length === 0){
			this.handleEmptyList(this.props)
		} else {
			this.checkIfUserHasAllLogos(this.props, currentRiddlesList)
		}

		return null
	}

	handleEmptyList = (props) =>{
		const { isUnlocking,
			gameType,
			isCheckingAnswer,
			isDownloadingRiddles,
			currentLevel,
			unlockLevel } = props;

		if(isUnlocking || isCheckingAnswer || isDownloadingRiddles){
			return
		} else {
			unlockLevel(gameType, currentLevel.unlockLimit);
		}
	};

	checkIfUserHasAllLogos = (props, currentRiddlesList) => {
		const { currentRiddleRange,
			gameType,
			currentLevel,
			unlockLevel } = props;


		const split = currentRiddleRange.split('-');
		if(!isNaN(split[0]) && !isNaN(split[1])){
			if(currentRiddlesList.length < parseInt(split[1]) - parseInt(split[0]) + 1){
				unlockLevel(gameType, currentLevel.unlockLimit);
			}
		}
	};

	render(){
		const { userRiddles,
			gameType,
			currentRiddleRange } = this.props;

		const gameTypeRiddles = userRiddles[gameType] || {};
		const currentRiddlesList = gameTypeRiddles[currentRiddleRange] || [];

		return (
			<LogosScreen {...this.props} userRiddles={currentRiddlesList}/>
		);
	}

}

LogosScreenContainer.propTypes = {
	currentRiddleRange: PropTypes.string.isRequired,
	gameType: PropTypes.string.isRequired,
	logoListScrollPositions: PropTypes.number.isRequired,
	isUnlocking: PropTypes.bool.isRequired,
	alreadyInvoked: PropTypes.bool.isRequired,
	isCheckingAnswer: PropTypes.bool.isRequired,
	isDownloadingRiddles: PropTypes.bool.isRequired,

	userRiddles: PropTypes.object.isRequired,
	currentLevel: PropTypes.object.isRequired,


	push: PropTypes.func.isRequired,
	setActiveRiddle: PropTypes.func.isRequired,
	updateScrollPosition: PropTypes.func.isRequired,
	unlockLevel: PropTypes.func.isRequired,
	unlockInvocation: PropTypes.func.isRequired,


};

function mapStateToProps(state) {
	const gameType = state.gameReducer.gameType;
	return {
		currentRiddleRange: state.screenReducer.currentRiddleRange,
		gameType,
		userRiddles: state.gameReducer.userRiddles,
		logoListScrollPositions: state.screenReducer.scrollPositions.logoList,
		isUnlocking: state.gameReducer.isUnlocking,
		isDownloadingRiddles: state.gameReducer.isDownloadingRiddles,
		currentLevel: state.gameReducer.currentLevel,
		isCheckingAnswer: state.gameReducer.isCheckingAnswer,

	};
}

export default connect(mapStateToProps,
	{ setActiveRiddle,
		updateScrollPosition,
		unlockLevel }
)(LogosScreenContainer);
